export const companyAuditLogsSeed = Array.from({ length: 50 }, (_, i) => ({
  id: `caud-${7000 + i}`,
  ts: new Date(Date.now() - i * 120000).toISOString(),
  actorEmail: `user${i % 12}@acme.example`,
  actorName: `User ${i % 12}`,
  module: ['Meetings', 'Templates', 'Users', 'Transcripts'][i % 4],
  action: ['VIEW', 'UPDATE', 'CREATE', 'DELETE'][i % 4],
  target: `resource-${i}`,
  result: i % 17 === 0 ? 'denied' : 'success',
  context: { requestId: `req-${i}`, ip: `198.51.100.${i % 40}` },
}));

export const userActivitySeed = Array.from({ length: 18 }, (_, i) => ({
  userId: `usr-${2100 + (i % 10)}`,
  displayName: `User ${i % 10}`,
  meetingsCreated: i % 6,
  updates: i % 5,
  momApprovals: i % 7 === 0 ? 2 : 0,
  lastActionAt: new Date(Date.now() - i * 7200000).toISOString(),
  events: [
    { at: new Date(Date.now() - i * 7200000).toISOString(), type: 'login', detail: 'SSO' },
    { at: new Date(Date.now() - i * 7000000).toISOString(), type: 'meeting_created', detail: 'mtg-3001' },
  ],
}));

export const exportHistorySeed = Array.from({ length: 12 }, (_, i) => ({
  id: `exp-${8000 + i}`,
  name: `${['Users', 'Audit', 'Transcripts'][i % 3]} export ${i + 1}`,
  requestedBy: i % 3 === 0 ? 'sara@acme.example' : 'admin@acme.example',
  createdAt: new Date(Date.now() - i * 86400000 * 2).toISOString(),
  format: ['CSV', 'XLSX'][i % 2],
  status: i === 0 ? 'processing' : i === 3 ? 'failed' : i === 5 ? 'expired' : 'ready',
  downloadUrl: i === 5 || i === 3 ? null : `https://exports.example/${8000 + i}.csv`,
}));
